<script lang="ts">
import {defineComponent, onMounted, ref, watch} from 'vue';
import MasterLayout from "~/layouts/MasterLayout.vue";
import {useTranslationStore, translation} from '~/plugins/store/translations';
import type {TranslationList} from "~/types/Utils";
import {useProductStore} from "~/plugins/store/product";
import {usePageStore} from "~/plugins/store/page";
import LoadingDialog from "~/components/utils/LoadingDialog.vue";

export default defineComponent({
  setup() {
    useHead({
      title: 'XIGA | Asigurari',
    });

    const pageStore = usePageStore();
    const {$toast} = useNuxtApp();
    const translationStore = useTranslationStore();
    const translationList = ref<TranslationList>({});
    const showLoadingDialog = ref(true);
    const messageLoadingDialog = ref('Se incarcă...');

    const news = ref<Page[] | null>([]);

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      showLoadingDialog.value = true;
      messageLoadingDialog.value = translation(translationList.value.loading, 'Se incarcă...');

      news.value = await pageStore.getNews(15);

      showLoadingDialog.value = false;
    });


    return {
      translationList,
      translation,
      news,
      showLoadingDialog,
      messageLoadingDialog,
    };
  },
  components: {LoadingDialog, MasterLayout},
  data: () => ({}),
});
</script>

<template>
  <master-layout class="news">
    <v-container class="content-container" style="padding: 0 !important;">
      <!-- Main container -->
      <v-container fluid class="component-container-full" style="padding: 0 !important;">
        <v-container fluid class="component-container-1400mw pa-15">
          <loading-dialog :message="messageLoadingDialog" :show-dialog="showLoadingDialog"/>
          <v-row v-if="news && news.length > 0" class="d-flex justify-center">
            <v-col cols="12" md="6" lg="4" v-for="item in news" :key="item.id">
              <v-card class="news-card pa-5" elevation="15">
                <NuxtImg v-if="item.featured_image"
                         :src="item.featured_image.url"
                         sizes="(max-width: 600px) 480px, 1024px"
                         class="w-100 h-100"
                         fit="cover"
                         alt="News"
                         loading="lazy"
                />

                <v-card-title class="news-title">{{ item.title }}</v-card-title>
                <v-card-actions class="news-actions justify-end">
                  <NuxtLink :to="'/info/'+item.slug" class="text-decoration-none color-white">
                    <v-btn
                        class="mx-1"
                        variant="text"
                        color="primary"
                        rounded="0"
                    >
                      {{
                        translation(translationList.read_more, "Citeste mai mult...")
                      }}
                    </v-btn>
                  </NuxtLink>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <!-- Undefined page -->
          <v-card v-else-if="(!news || news.length === 0) && !showLoadingDialog"
                  class="d-flex flex-column justify-center align-center" height="500px" color="transparent" flat>
            <div class="fw-500 fs-50">
              {{
                translation(translationList.no_news, "Momentan nu exista stiri.")
              }}
            </div>
          </v-card>
        </v-container>
      </v-container>
    </v-container>
  </master-layout>
</template>

<style scoped>
</style>
